import http from '@/http'
const URL = '/admin/settings/email'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const saveReward = (payload) => {
  let id = ''
  if (payload.id) {
    id = payload.id
  }
  return http.post(URL + `/${id}`, payload)
}

export const newTemplate = (payload) => {
  let id = ''
  if (payload.id) {
    id = payload.id
  }
  return http.post(URL + `/${id}`, payload)
}

export const sendEmail = (payload) => {
  return http.post(URL + '/test', payload)
}
export const sendNotification = (payload) => http.post(URL + `/notification`, payload)
export const changeStatus = () => http.put(URL + `/status`)
export const removeHeader = (payload) => http.put(URL + `/${payload}/clearHeader`)

export const orderList = async (payload) => http.put(URL + `/sequence`, payload)

export const deleteTemplate = async (id) => http.delete(URL + `/${id}`)

export const variables = () => http.get(URL + '/variables')

export default {
  list,
  show,
  orderList,
  saveReward,
  newTemplate,
  sendEmail,
  sendNotification,
  changeStatus,
  removeHeader,
  deleteTemplate,
  variables
}
